module.exports = __webpack_public_path__ + "img/maintenance_fixed.328009b9.svg";